import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Discussions } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { forwardRef } from "react";
import { useSelector } from "react-redux";
import { centralizedClipSelector } from "~/store/centralizedClip/selectors";
export const DiscussionsMenuButton = /*#__PURE__*/ forwardRef((props, ref)=>{
    const asset = useSelector(centralizedClipSelector);
    return /*#__PURE__*/ _jsxs(Button, {
        appearance: "ghost",
        className: "px-1",
        color: "grey",
        ref: ref,
        size: "small",
        ...props,
        children: [
            /*#__PURE__*/ _jsx(Discussions, {
                className: "size-4"
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "ml-1",
                children: asset.openCommentCount
            })
        ]
    });
});
DiscussionsMenuButton.displayName = "DiscussionsMenuButton";
